import { render, staticRenderFns } from "./SectorDialogComponent.vue?vue&type=template&id=5ddc463d&scoped=true"
import script from "./SectorDialogComponent.js?vue&type=script&lang=js&external"
export * from "./SectorDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./SectorDialogComponent.vue?vue&type=style&index=0&id=5ddc463d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddc463d",
  null
  
)

export default component.exports